<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useToastStore } from '@/stores/use-toast-store'

const { hideToast } = useToastStore()
const { toastList } = storeToRefs(useToastStore())

function handleCloseToast(id: string | number) {
  hideToast(id)
}
</script>

<template>
  <section class="toast-container position-fixed">
    <div
      v-for="data in toastList"
      :key="data.id"
      aria-atomic="true"
      aria-live="assertive"
      class="toast fade"
      role="alert"
      :class="{
        toast_info: data.type === 'info',
        toast_success: data.type === 'success',
        toast_warn: data.type === 'warn',
        'hide-btn-close': data.hideBtnClose,
        'has-header': data.hasHeader,
        show: data.isShow
      }"
    >
      <div class="toast-content-wrap">
        <svg aria-hidden="true" class="icon toast-icon mr-8 mt-1">
          <use :xlink:href="`#${data.iconName}`" />
        </svg>
        <div class="toast-content me-auto">
          <div
            v-if="data.title || data.titleElement"
            class="toast-header text--lg d-block"
          >
            <div v-if="data.title" class="toast-title-content">
              {{ data.title }}
            </div>
            <div v-if="data.titleElement" class="toast-title-element-content">
              <component :is="data.titleElement" />
            </div>
          </div>
          <div
            v-if="data.message || data.messageElement"
            class="toast-body text--sm d-block"
          >
            <div v-if="data.message" class="toast-message-content">
              {{ data.message }}
            </div>
            <div
              v-if="data.messageElement"
              class="toast-message-element-content"
            >
              <component :is="data.messageElement" />
            </div>
          </div>
        </div>
        <button
          aria-label="Close"
          class="btn-close ml-8"
          data-bs-dismiss="toast"
          type="button"
          :title="$t('Common.AppToast.CloseErrorMessage')"
          @click="handleCloseToast(data.id)"
        >
          <svg class="icon icon-close mr-2">
            <use xlink:href="#Close" />
          </svg>
        </button>
      </div>
    </div>
  </section>
</template>
